import * as ReactDOM from 'react-dom';

export * from 'react-dom';

const isDomNode = (value) =>
  typeof Node !== 'undefined' && value instanceof Node;

const findHostNodeInFiber = (fiber) => {
  if (!fiber) {
    return null;
  }

  if (isDomNode(fiber.stateNode)) {
    return fiber.stateNode;
  }

  let childNode = findHostNodeInFiber(fiber.child);

  if (childNode) {
    return childNode;
  }

  childNode = findHostNodeInFiber(fiber.sibling);

  return childNode;
};

export const findDOMNode = (componentOrElement) => {
  if (!componentOrElement) {
    return null;
  }

  if (isDomNode(componentOrElement)) {
    return componentOrElement;
  }

  if (isDomNode(componentOrElement.current)) {
    return componentOrElement.current;
  }

  if (isDomNode(componentOrElement.node)) {
    return componentOrElement.node;
  }

  if (isDomNode(componentOrElement.element)) {
    return componentOrElement.element;
  }

  const fiber =
    componentOrElement._reactInternals ||
    componentOrElement._reactInternalFiber;

  const hostNode = findHostNodeInFiber(fiber);

  if (hostNode) {
    return hostNode;
  }

  return null;
};

export default {
  ...ReactDOM,
  findDOMNode,
};
